var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEkonomiczna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16427588631529659198 1",
    clipPath: "url(#clip0_66_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.842064 1.13895L9.45288 3.28938C9.98038 3.44407 10.4461 3.76035 10.7843 4.19368C11.1226 4.62701 11.3163 5.15554 11.3383 5.70482V13.4798C11.3524 13.7163 11.3093 13.9526 11.2126 14.1688C11.1159 14.3851 10.9684 14.5747 10.7827 14.7218C10.597 14.8688 10.3785 14.9689 10.1459 15.0134C9.91325 15.058 9.6733 15.0458 9.4464 14.9778L2.21565 13.2777C1.68746 13.1318 1.2194 12.8216 0.879259 12.392C0.539117 11.9624 0.344549 11.4357 0.32373 10.8882V2.46523C0.325269 1.95019 0.53055 1.45669 0.894741 1.09249C1.25893 0.728304 1.75244 0.523023 2.26748 0.521484H13.2821C13.7971 0.523023 14.2906 0.728304 14.6548 1.09249C15.019 1.45669 15.2243 1.95019 15.2258 2.46523V9.59232C15.2244 10.1074 15.0192 10.601 14.655 10.9652C14.2908 11.3295 13.7972 11.5347 13.2821 11.5361H11.3383",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.15527 2.46533H12.6344",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.42279 10.2403C9.13846 10.2403 9.71862 9.66018 9.71862 8.94451C9.71862 8.22885 9.13846 7.64868 8.42279 7.64868C7.70712 7.64868 7.12695 8.22885 7.12695 8.94451C7.12695 9.66018 7.70712 10.2403 8.42279 10.2403Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.3384 5.70483H12.6342",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_4205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.55,
    height: 15.55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkonomiczna);
export default __webpack_public_path__ + "static/media/ekonomiczna.24209d7f53e9091697cc9f91b081fcfc.svg";
export { ForwardRef as ReactComponent };